module.exports = __webpack_public_path__ + "static/media/octes8h_7.1c10f399.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/octes/octes8h_7.svg
// module id = 752
// module chunks = 0